import React, {Component, Fragment} from 'react';
import {inject, observer} from "mobx-react/index";
import {withRouter, Link} from "react-router-dom";
import {Table, Card, Tooltip, Icon, Tag, Avatar, Menu, Dropdown, Button, Modal, Badge} from 'antd';
import moment from 'moment-timezone';
import {CreatePositionModal} from "./CreatePositionModal";
import {ImportPositionModal} from "./ImportPositionModal";
const SubMenu = Menu.SubMenu;

@inject('store')
@withRouter
@observer
export class OpenPositionsTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            createPositionModal: false,
            importPositionModal: false,
            selectedRows: [],
            showDrawer: false
        }
    }

    handleMenuSelect(selection) {

        const path = selection.keyPath.reverse();
        const key = path[0];

        switch (key) {
            case 'import_position':
                this.setState({importPositionModal: true});
                return;
            case 'manual_buy':
                this.setState({createPositionModal: true});
                return;
            case 'panic_sell':
                Modal.confirm({
                    title: 'Panic sell?',
                    content: 'This will sell all open positions',
                    onOk: () => {
                        this.props.store.botStore.actionStore.execute('panic_sell');
                        this.setState({selectedRows: []});
                    }
                });
                return;
            case 'panic_sell_stable':
                Modal.confirm({
                    title: 'Panic sell and sell to stable coin?',
                    content: 'This will sell all open positions',
                    onOk: () => {
                        this.props.store.botStore.actionStore.execute('panic_sell_stable');
                        this.setState({selectedRows: []});
                    }
                });
                return;
            case 'panic_sell_rebuy':
                Modal.confirm({
                    title: 'Sell stable coin and rebuy base?',
                    onOk: () => {
                        this.props.store.botStore.actionStore.execute('panic_sell_rebuy');
                        this.setState({selectedRows: []});
                    }
                });
                return;
            case 'market_sell_positions':
                Modal.confirm({
                    title: 'Market sell selected positions?',
                    onOk: () => {
                        this.props.store.botStore.actionStore.execute('market_sell_positions', {position_ids: this.state.selectedRows});
                        this.setState({selectedRows: []});
                    }
                });
                return;
            case 'limit_sell_positions':
                Modal.confirm({
                    title: 'Limit sell selected positions at current price?',
                    onOk: () => {
                        this.props.store.botStore.actionStore.execute('limit_sell_positions', {position_ids: this.state.selectedRows});
                        this.setState({selectedRows: []});
                    }
                });
                return;
            case 'toggle_auto_dca_status_bulk':
                Modal.confirm({
                    title: 'Toggle DCA status of selected positions?',
                    onOk: () => {
                        this.props.store.botStore.actionStore.execute('toggle_auto_dca_status_bulk', {position_ids: this.state.selectedRows});
                        this.setState({selectedRows: []});
                    }
                });
                return;
            case 'toggle_sell_on_ta_status_bulk':
                Modal.confirm({
                    title: 'Toggle Sell on TA status of selected positions?',
                    onOk: () => {
                        this.props.store.botStore.actionStore.execute('toggle_sell_on_ta_status_bulk', {position_ids: this.state.selectedRows});
                        this.setState({selectedRows: []});
                    }
                });
                return;
            case 'toggle_auto_reverse_status_bulk':
                Modal.confirm({
                    title: 'Toggle Auto Reverse status?',
                    onOk: () => {
                        this.props.store.botStore.actionStore.execute('toggle_auto_reverse_status_bulk', {position_ids: this.state.selectedRows});
                        this.setState({selectedRows: []});
                    }
                });
                return;


            case 'set_sell_strategy':
                this.props.store.botStore.actionStore.execute('set_sell_strat_bulk',{strategy_id: path[1], position_ids: this.state.selectedRows});
                this.setState({selectedRows: []});
                return;
            case 'set_stop_loss':
                this.props.store.botStore.actionStore.execute('set_stop_loss_bulk',{percent: parseFloat(path[1]), position_ids: this.state.selectedRows});
                this.setState({selectedRows: []});
                return;
            case 'delete_positions_bulk':
                Modal.confirm({
                    title: 'Delete selected positions?',
                    content: 'Positions will be removed and orders cancelled on the exchange',
                    onOk: () => {
                        this.props.store.botStore.actionStore.execute('delete_positions_bulk',{position_ids: this.state.selectedRows});
                        this.setState({selectedRows: []});
                    }
                });
                return;
            default: //noop

        }
    }


    render() {
        const timezone = this.props.store.userStore.currentUser.timezone

        const schema = [
            {
                title: '',
                dataIndex: 'source',
                key: 'source',
                render(text, o) {
                    switch(o.source) {
                        case 'mh': 
                        case 'cbs':
                        case 'TV': return <Tooltip title={`Group: ${o.group || 'None'}`} ><Avatar  alt={`signal source ${o.source} logo`} src={`/signals/${o.source}.png`}/></Tooltip>
                        
                        default: return null;
                    }
                }
            },
            {
                title: '',
                dataIndex: 'icon',
                key: 'icon',
                render(text, o) {
                    const iconstyle = {fontSize: 24};
                    const taEnabled = o.sell_strategy_config && o.sell_strategy_config.ta_enabled ? <span><Icon type="stock" className={'success'} style={iconstyle}/></span> : null;

                    let adca = o.auto_dca_enabled ? <Icon type="safety" className={'success'} style={iconstyle} /> : null;

                    if (o.auto_dca_error) adca = <Tooltip title={"Auto DCA: error detected check the journal for details"}><Icon type="warning" style={iconstyle} className={'error'}/></Tooltip>;
                    if (o.auto_dca_scanning) adca = <Icon type="safety" style={{...iconstyle, color:"#ffd841"}} />;

                    let artDelta = null;
                    if (o.rt_auto_sell_price) {
                        const value = (((o.rt_auto_sell_price-o.avg_buy_price) / o.avg_buy_price) * 100);
                        artDelta = <span>Auto Sell: {o.rt_auto_sell_price.toFixed(8)} {value.toFixed(2)}%</span>;
                    }
                    let art = o.auto_reverse_enabled ? <Tooltip title={artDelta}><Icon type="fund" className={'success'} style={iconstyle} /></Tooltip> : null;
                    return <span>
                        {taEnabled}&nbsp;
                        {adca ? <Badge count={o.auto_dca_level||0}>{adca}</Badge> : null}&nbsp;
                        {art ? <Badge count={o.auto_rt_level||0}>{art}</Badge> : null}
                    </span>

                }
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
                render(text) {
                    let color = null;
                    if (text === 'SELL_ORDER_PLACED') color = '#29c0b1';
                    if (text === 'BUY_ORDER_PLACED') color = '#2c50ed';
                    if (text === 'TRADING') color = '#fbbc06';
                    if (text === 'STOP_LOSS_PLACED') color = '#ff3366';
                    return <Tag color={color}>{text ? text.replace(/_/g,' ') : text}</Tag>
                }
            },
            {
                title: 'Symbol',
                dataIndex: 'base',
                key: 'base',
                sorter: (a, b) => {
                    if (a.base < b.base) return -1;
                    if (a.base > b.base) return 1;
                    return 0;
                },
                render: (text, position) => {
                    let url = `https://uk.tradingview.com/chart?symbol=binance%3A${position.baseId}${position.quoteId}`;
                    if (this.props.store.botStore.currentConfiguration.exchange === 'kucoin') {
                        url = `https://www.kucoin.com/trade/${position.baseId}-${position.quoteId}`;
                    }

                    return <a onClick={() => window.open(url,'_blank')}><Avatar width={"24px"} src={`/symbols/${text}.png`}/> {text}</a>
                }
            },
            {
                title: 'Held',
                dataIndex: 'amount_heldyeah',
                key: 'amount_held',
                sorter: (a, b) => parseFloat(a.amount_held||0) - parseFloat(b.amount_held||0),
                render: (text, record) => {
                    return `${(record.amount_held||0).toFixed(3)}`
                }
            },
            {
                title: 'Purchase Price',
                dataIndex: 'avg_buy_price',
                key: 'avg_buy_price',
                sorter: (a, b) => {
                    return a.avg_buy_price - b.avg_buy_price;
                },
                render: (text, o) => {
                    if (text) {

                        return text.toFixed ? text.toFixed(8) : text;
                    }
                    return o.price || '-';
                }
            },
            {
                title: 'Breakeven Price',
                dataIndex: 'breakeven_price',
                key: 'breakeven_price',
                render: (text, record) => {
                    return (record.breakeven_price||0).toFixed(8);
                }
            },
            {
                title: 'Total Cost ',
                dataIndex: 'max_cost',
                key: 'max_cost',
                sorter: (a, b) => {
                    return a.max_cost - b.max_cost;
                },
                render: (text, o) => {
                    return (text||0).toFixed(8)
                }
            },
            {
                title: 'Target',
                dataIndex: 'arm_target',
                key: 'arm_target',
                render: (text, o) => {

                    if (o.is_manual_sell){
                        return `Manual: ${(o.target_price && o.target_price.toFixed(8))} (${(((o.target_price-o.avg_buy_price) / o.avg_buy_price) * 100).toFixed(2)}%)`;
                    }

                    switch (o.status) {
                        case 'TRADING':
                            if (o.sell_strategy_config && o.sell_strategy_config.type === 'trail') {
                                if (o.arm_armed) {
                                    return <Tooltip title="Armed">
                                        <Icon type="rocket" className="success"/> ST: {o.arm_stop_loss.toFixed(8)}
                                    </Tooltip>
                                }
                                return o.arm_target ? `AT: ${o.arm_target.toFixed(8) } ST: ${o.arm_stop_loss.toFixed(8) }`:'-'
                            }
                            return '-';
                        case 'SELL_ORDER_PLACED':
                            if (o.sell_strategy_config && o.sell_strategy_config.type === 'trail') {
                                const value = (((o.arm_stop_loss - o.price) / o.price) * 100);
                                let profit = <span>{value.toFixed(2)}%</span>;
                                if (value > 0) profit = <span className="success">{value.toFixed(2)}%</span>;
                                if (value < 0) profit = <span className="error">{value.toFixed(2)}%</span>;

                                if (o.arm_armed) {
                                    return <Tooltip title="Armed"><Icon type="rocket" className="success"/> ST: {o.arm_stop_loss.toFixed(8)} {profit}</Tooltip>
                                }
                                return `AT: ${o.target_price ? o.target_price.toFixed(8) : '-' } ST: ${o.arm_stop_loss ? o.arm_stop_loss.toFixed(8) : '-'}`
                            }
                            return `${o.sell_strategy_config.type === 'apex_percent_profit' ? 'DPP' : 'PP'}: ${(o.target_price && o.target_price.toFixed(8))} (${(((o.target_price-o.avg_buy_price) / o.avg_buy_price) * 100).toFixed(2)}%)`;
                        case 'TRAILING':
                            return o.buy_arm_target ? `AT: ${o.buy_arm_target.toFixed(8) } BT: ${o.buy_arm_stop_loss.toFixed(8)}` : '-';
                        case 'STOP_LOSS_PLACED':
                            return o.stop_loss || '';
                        default:
                            return '-';
                    }
                }
            },
            {
                title: 'Current Price',
                dataIndex: 'current_price',
                key: 'current_price',
                sorter: (a, b) => {
                    return a.current_price - b.current_price;
                },
                render: (text) => text ? text.toFixed(8) : '-'
            },{
                title: 'Result w/fees',
                dataIndex: 'result',
                key: 'result',
                width: 90,
                sorter: (a, b) => {
                    return (a.result||0)-(b.result||0);
                },
                render: (text, record) => {
                    if (record.status === "REVERSING" || record.status === "SELL_ORDER_PLACED" || record.status === "STOP_LOSS_PLACED" || record.status === "TRADING" ||  record.status === "PARTIALLY_FILLED") {
                        let kpi = '';
                        if (record.status === "REVERSING") {

                           kpi = ((record.rt_last_sell_price-record.current_price)/record.current_price)*100;
                           if (kpi >= 0) {
                               kpi = <span className="success"><br/><Tooltip title={`Result from sell price (${record.rt_last_sell_price})`}><Icon type="fund"/> {kpi.toFixed(2)}% </Tooltip></span>
                           } else {
                               kpi = <span className="error"><br/><Tooltip title={`Result from sell price (${record.rt_last_sell_price})`}><Icon type="fund"/> {kpi.toFixed(2)}% </Tooltip></span>
                           }
                        }

                        if (record.status !== "REVERSING" && record.rt_last_buy_price) {
                            kpi = ((record.current_price-record.rt_last_buy_price)/record.rt_last_buy_price)*100;
                            if (kpi >= 0) {
                                kpi = <span className="success"><br/><Tooltip title={`Result from buy price (${record.rt_last_buy_price})`}><Icon type="fund"/> {kpi.toFixed(2)}% </Tooltip></span>
                            } else {
                                kpi = <span className="error"><br/><Tooltip title={`Result from buy price (${record.rt_last_buy_price})`}><Icon type="fund"/> {kpi.toFixed(2)}% </Tooltip></span>
                            }
                        }

                        const value = record.result_w_fees || record.result
                        if (value > 0) return <Fragment><span className="success">{value.toFixed(2)}% </span>{kpi}</Fragment>
                        if (value < 0) return <Fragment><span className="error">{value.toFixed(2)}% </span>{kpi}</Fragment>
                        if (value === 0) return <Fragment><span>{value.toFixed(2)}% </span>{kpi}</Fragment>

                    }
                    return "-"
                }
            },
            {
                title: 'Exposure',
                dataIndex: 'exposure',
                key: 'exposure',
                defaultSortOrder: 'descend',
                sorter: (a, b) => {
                    return a.created_at - b.created_at;
                },
                render: (text, record) => moment(record.created_at).tz(timezone).fromNow()
            },
            {
                title: 'Actions',
                dataIndex: 'actions',
                key: 'actions',
                defaultSortOrder: 'descend',
                render: (text, position) => <span><i className="fal fa-analytics"></i><Link to={`/a/bot/${this.props.match.params.id}/position/${position.id}`}>  Position Details</Link></span>
            }
        ];

        const menu = (
            <Menu onClick={this.handleMenuSelect.bind(this)}>
                <Menu.Item key="import_position">Import Position</Menu.Item>
                <Menu.Item key="manual_buy">Manual Buy</Menu.Item>
                <Menu.Divider />
                <Menu.Item key="market_sell_positions">Market Sell Positions</Menu.Item>
                <Menu.Item key="limit_sell_positions">Limit Sell Positions (Current Price)</Menu.Item>
                <Menu.Divider />
                <SubMenu key="set_sell_strategy" title={"Set Sell Strategy"}>
                    { [...this.props.store.strategyStore.signal, ...this.props.store.strategyStore.buySell].sort((a, b) => {
                        if(a.name < b.name) return -1;
                        if(a.name > b.name) return 1;
                        return 0;
                    }).filter((s) => !s.trigger).map((s) => {
                        return <Menu.Item key={s.id}>{s.name}</Menu.Item>
                    })}
                </SubMenu>
                <SubMenu key="set_stop_loss" title={"Set Stop Loss"}>
                    <Menu.Item key="0.005">0.5%</Menu.Item>
                    <Menu.Item key="0.01">1%</Menu.Item>
                    <Menu.Item key="0.015">1.5%</Menu.Item>
                    <Menu.Item key="0.02">2%</Menu.Item>
                    <Menu.Item key="0.03">3%</Menu.Item>
                    <Menu.Item key="0.04">4%</Menu.Item>
                    <Menu.Item key="0.05">5%</Menu.Item>
                </SubMenu>
                <Menu.Divider />
                <Menu.Item key="toggle_auto_dca_status_bulk">Toggle Auto DCA Status</Menu.Item>
                <Menu.Item key="toggle_sell_on_ta_status_bulk">Toggle Sell on TA</Menu.Item>
                <Menu.Item key="toggle_auto_reverse_status_bulk">Toggle Auto Reverse</Menu.Item>
                <Menu.Divider />
                <Menu.Item key="delete_positions_bulk">Delete Positions</Menu.Item>
                <Menu.Divider />
                <Menu.Item key="panic_sell">Panic Sell</Menu.Item>
                <Menu.Item key="panic_sell_stable">Panic Sell to Stable</Menu.Item>
                <Menu.Item key="panic_sell_rebuy">Rebuy Base</Menu.Item>


            </Menu>
        );

        return <Fragment>

            <Card title={`${this.props.store.botStore.positions.length}/${this.props.store.botStore.currentConfiguration.max_positions} Open Positions`}
                  bordered={false}
                  extra={
                      <Dropdown overlay={menu}>
                          <Button>
                              Actions <Icon type="down" />
                          </Button>
                      </Dropdown>
                  } >

                <Table
                    dataSource={this.props.store.botStore.positions.filter((a) => a.status !== 'COMPLETE')}
                    rowKey="id"
                    rowSelection={
                        {
                            getCheckboxProps: record => ({
                                disabled: record.status === 'NOT_ENOUGH_TO_SELL', // Column configuration not to be checked
                                name: record.name,
                            }),
                            selectedRowKeys: this.state.selectedRows,
                            onChange: (selectedRowKeys, selectedRows) => {
                                this.setState({selectedRows: selectedRowKeys});
                            },
                            hideDefaultSelections: true
                        }
                    }
                    scroll={{ x: 1000}}
                    // onRow={(position) => {
                    //     return {
                    //         onClick: (event) => {
                    //             this.props.history.push(`/a/bot/${this.props.match.params.id}/position/${position.id}`);
                    //         }
                    //     };
                    // }}
                    pagination={{ defaultPageSize: 25, showSizeChanger: true, pageSizeOptions: ['10', '25', '50', '100'] }}
                    columns={schema} />
                <p>
                    <Icon type="fund" className={'success'}/> Auto RT is enabled &nbsp;&nbsp;
                    <Icon type="safety" style={{color: '#ffd841'}}/> Auto DCA is scanning &nbsp;&nbsp;
                    <Icon type="safety" className={'success'}/> Auto DCA is enabled &nbsp;&nbsp;
                    <Icon type="stock" className={'success'} /> Sell on TA enabled
                </p>
            </Card>

            <CreatePositionModal
                visible={this.state.createPositionModal}
                onCancel={() => this.setState({createPositionModal: false})}
            />

            <ImportPositionModal
                visible={this.state.importPositionModal}
                onCancel={() => this.setState({importPositionModal: false})}
            />
        </Fragment>
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/PositionsView/OpenPositionsTable.js